import withLayout from "./containers/withLayout";

export default withLayout;
